<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 13:27:18
 * @fileName     :
 * @Description  : 我的付款申请详情
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <el-row :gutter="20">
        <el-col :span="18">
          <descriptions v-if="!showDesc" :span="6" :status="status" :row-data="rowData" :rules="rules"
            :columns="columns" ref="descriptionsRef">
            <template #supplierSlot="{ data }">
              <div class="flex items-center">
                <div>
                  <!--供应商 -->
                  <el-select clearable v-model="payContractForm.supplierId" filterable @change="(e) => changeValue(e, data)"
                    :disabled="data.disabled" :placeholder="data.placeholder">
                    <el-option v-for="item in supplierOption" :key="item.id" :label="item.supplierName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </template>
            <template #ownerSlot="{ data }">
              <div class="flex items-center">
                <div>
                  <!--付款单位 -->
                  <el-select clearable v-model="payContractForm.ownerId" filterable @change="(e) => changeValue(e, data)"
                    :disabled="data.disabled" :placeholder="data.placeholder">
                    <el-option v-for="item in ownerOption" :key="item.id" :label="item.unitName" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </template>
            <template #contractReceivePaymentSlot="{ data }">
              <div class="flex items-center">
                <div>
                  <!--付款合同 -->
                  <el-select clearable multiple v-model="contractMakePaymentId" :disabled="data.disabled" filterable
                    remote reserve-keyword placeholder="请选择合同名称"
                    :remote-method="(e) => remoteMethod(e, 'contractMakePaymentId')" :loading="selectLoading"
                    style="min-width: 600px">
                    <el-option v-for="item in contractMakePaymentOption" :key="item.id" :label="item.contractName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>

              </div>
            </template>
            <template #relatedItemsReceivePaymentSlot="{ data }">
              <div class="flex items-center">
                <div>
                  <!--关联项付款情况 -->
                  <el-table :data="contractReceivePaymentList" border style="width: 100%;color: black">
                    <el-table-column type="expand" width="30px">
                      <template slot-scope="props">
                        <div class="flex justify-center" style="background-color: #79bbff">
                          <el-form label-position="left" inline class="table-expand-box">
                            <el-form-item label="收款合同编码" style="width: 160px">
                              <span>{{ props.row.receiveContractCode }}</span>
                            </el-form-item>
                            <el-form-item label="收款合同名称" style="width: 200px">
                              <span>{{ props.row.receiveContractName }}</span>
                            </el-form-item>
                            <el-form-item label="收款合同总额" style="width: 120px">
                              <span>{{ props.row.totalAmount }}</span>
                            </el-form-item>
                            <el-form-item label="已开票" style="width: 100px">
                              <span>{{ props.row.invoicedAmount }}</span>
                            </el-form-item>
                            <el-form-item label="未开票" style="width: 100px;color: red;font-weight: bold">
                              <span>{{ props.row.noInvoicedAmount }}</span>
                            </el-form-item>
                            <el-form-item label="已收款" style="width: 100px">
                              <span>{{ props.row.receivedAmount }}</span>
                            </el-form-item>
                            <el-form-item label="未收款" style="width: 100px;color: red;font-weight: bold">
                              <span>{{ props.row.noReceivedAmount }}</span>
                            </el-form-item>
                          </el-form>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-for="(cItem, cIndex) in data.columns" :key="cIndex" :prop="cItem.key"
                      :label="cItem.label" :min-width="cItem.width" :align="cItem.align">
                      <template slot-scope="{row}">
                        <span>{{ row[cItem.key] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
            <template #makePaymentPlanSlot="{ data }">
              <div class="flex items-center">
                <div>
                  <!--付款计划 -->
                  <el-table :data="makePaymentPlanList" row-key="id" ref="makePaymentPlanIdRef" border
                    style="width: 100%;color: black" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" :selectable="disabledSelect" width="55">
                    </el-table-column>
                    <el-table-column v-for="(cItem, cIndex) in data.columns" :key="cIndex" :prop="cItem.key"
                      :label="cItem.label" :min-width="cItem.width" :align="cItem.align">
                      <template slot-scope="{row}">
                        <el-tag v-if="cItem.key == 'ifPay'" 
                          :type="isPaid(row[cItem.key]) ? 'success' : 'danger'"
                          effect="dark">
                          {{ isPaid(row[cItem.key]) ? "是" : "否" }}
                        </el-tag>
                        <span v-else>{{ row[cItem.key] }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
          </descriptions>
          <auditCom v-if="toExamine && dialogDrawer" @refreshInitData="childReviewer"></auditCom>
        </el-col>
        <el-col :span="6">
          <div class="approval-progress">
            <div class="progress-box" >
              <div class="progress-title">审批流程</div>
              <div class="progress-desc-info flex flex-wrap">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="(item, index) in processDescInfo" :key="index">
                    <div class="items">
                      <el-avatar shape="square" size="large"
                          :src="item ? imageUrlprefix + item : defaultAvatar"></el-avatar>
                    </div>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
            <div class="progress-title" v-if="status !== 'add'">审批进度</div>
            <div class="progress-con" v-if="status !== 'add'">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in processList" :key="index" size="large"
                  :icon="auditProcessStatus(item.auditStatus).icon" :color="auditProcessStatus(item.auditStatus).color">
                  <el-row :gutter="15">
                    <el-col :span="6">
                      <div>
                        <el-image v-if="item.typeLabel == '抄送人'" style="width: 40px;height: 40px;"
                          :src="require('@/assets/makeACopyFor.png')" fit="cover"></el-image>
                        <el-avatar shape="square" v-else size="large"
                          :src="item.avatar ? imageUrlprefix + item.avatar : defaultAvatar"></el-avatar>
                      </div>
                    </el-col>
                    <el-col :span="18" v-if="item.typeLabel == '抄送人'">
                      <div class="makeACopyFor-desc">
                        <div class="makeACopyFor-title">
                          {{ item.typeLabel }}
                        </div>
                        <div class="makeACopyFor-num">
                          已抄送{{ item.userList ? item.userList.length : 0 }}人
                        </div>
                        <div class="makeACopyFor-box flex justify-start items-center flex-wrap">
                          <div class="child-items" v-for="(cItem, cIndex) in item.userList" :key="cIndex">
                            <el-avatar shape="square" size="large"
                              :src="cItem.userAvatar ? imageUrlprefix + cItem.userAvatar : defaultAvatar"></el-avatar>
                            <div class="child-text">{{ cItem.userName }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18" v-else>
                      <div class="progress-desc">
                        <div><span>{{ item.name }}</span><span class="progress-time">{{ item.date }}</span></div>
                        <div>{{ item.typeLabel }}</div>
                        <div :style="{ color: auditProcessStatus(item.auditStatus).color, fontSize: '18px' }">{{
                          item.auditLabel }}</div>
                        <div class="signature-box flex justify-start items-center" v-if="item.signatureUrl">
                          <span class="signature-title">签名</span>
                          <el-image class="signature-img" :src="imageUrlprefix + item.signatureUrl"
                            fit="contain"></el-image>
                        </div>
                        <el-tooltip class="item" effect="dark" :content="item.auditComment" placement="top-start">
                          <p class="notes-text" v-if="item.auditStatus == 2 || item.auditStatus == 9">
                            {{ item.auditComment }}
                          </p>
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-row>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <el-button type="primary" @click="temporarilyStore()" v-if="status == 'add' || status == 'edit'">暂存</el-button>
      <el-button @click="clearForm()" v-if="status == 'add' || status == 'edit'">清空</el-button>
    </div>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { queryFinMakePaymentDetailsApi, addFinMakePaymentApi, editFinMakePaymentApi, processFinMakePaymentApi, getMakePaymentDataApi, getContractMakePaymentPlanApi, getInvoiceAndReceivedDataApi, getListYtgBySupAndOwnApi, reAddFinMakePaymentApi, queryAuditProcessDescriptionApi } from '@/api/paymentApplication/index'
import { queryBasicSuppliersListApi, queryBasicOwnersListApi } from '@/api/basicInfo/index'
import { auditProcessStatus, convertToNumberEnhanced } from '@/utils/index'
import { dataPage } from "@/api/sys/dictData";
import auditCom from "@/components/auditCom/index.vue"
export default {
  components: {
    descriptions,
    auditCom
  },
  props: {
    toExamine: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '付款申请详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  watch: {
    contractMakePaymentId(sItem, eItem) {

      if (eItem.length > sItem.length) {
        this.makePaymentPlanList = this.makePaymentPlanList.filter(item => this.contractMakePaymentId.includes(item.id));
        this.multipleSelection = this.multipleSelection.filter(item => this.contractMakePaymentId.includes(item.contractId))
      } else {
        for (let i = 0; i < this.contractMakePaymentId.length; i++) {
          this.reverseDisplayList(this.contractMakePaymentId[i], 'contractMakePaymentId', 'all')
        }
      }
    }
  },
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      dialogDrawer: false,
      contractMakePaymentId: [],
      selectLoading: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        { key: 'makePaymentName', label: '付款申请名称', span: 6, placeholder: '客户名称+业务描述', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'supplierId', label: '供应商', span: 3, placeholder: '选择供应商', input: 'select', type: 'text', disabled: true, defaultValue: '', slotName: 'supplierSlot' },
        { key: 'ownerId', label: '付款单位', span: 3, placeholder: '请选择付款单位', input: 'select', type: 'text', disabled: true, defaultValue: '', slotName: 'ownerSlot' },
        { key: 'contractMakePaymentId', label: '关联合同', span: 6, placeholder: '请选择付款关联合同', disabled: true, defaultValue: '', slotName: 'contractReceivePaymentSlot' },
        {
          key: 'relatedItemsReceivePayment', height: 'auto', label: '付款合同情况', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false, slotName: 'relatedItemsReceivePaymentSlot',
          columns: [
            { label: '付款合同编码', key: 'contractMakePaymentCode', width: '160px', align: 'center', input: 'input', required: true, defaultValue: "" },
            { label: '付款合同名称', key: 'contractMakePaymentName', width: '200px', placeholder: '请输入预计金额', align: 'center', input: 'input', defaultValue: "" },
            { label: '付款合同金额(元)', key: 'contractMakePaymentAmount', width: '200px', placeholder: '请输入预计日期', align: 'center', input: 'date', defaultValue: "" },
            { label: '已付款金额(元)', key: 'contractMakePaymentPaidAmount', width: '200px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
            { label: '未付款金额(元)', key: 'contractMakePaymentNoPaidAmount', width: '200px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        { key: 'telecomOperatorSignComCode', label: '与运营商签约公司', span: 3, placeholder: '选择运营商签约公司', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'dictLabel', valueKey: 'dictValue' },
        { key: 'telecomOperatorCode', label: '运营商', span: 3, placeholder: '选择运营商', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'dictLabel', valueKey: 'dictValue' },
        {
          key: 'makePaymentMethodType', label: '付款方式', span: 3, placeholder: '请选择付款方式', input: 'radio', type: '', disabled: true, defaultValue: '', option: [
            { label: '一次性全款', value: '1' },
            { label: '阶段性付款', value: '2' },
          ]
        },
        { key: 'paymentTypeCode', label: '付款类型', span: 3, placeholder: '选择付款类型', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'dictLabel', valueKey: 'dictValue' },
        { key: 'bankName', label: '开户银行', span: 3, placeholder: '请输入开户银行', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'bankAccount', label: '银行账号', span: 3, placeholder: '请输入银行账号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'makePaymentAmount', label: '已付款', span: 3, placeholder: '已付款', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'noMakePaymentAmount', label: '未付款', span: 3, placeholder: '未付款', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        {
          key: 'makePaymentPlanList', height: 'auto', label: '付款计划', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false, slotName: 'makePaymentPlanSlot',
          columns: [
            { label: '阶段', key: 'stage', width: '150px', align: 'center', placeholder: '请输入阶段', input: 'input', defaultValue: "", },
            { label: '付款合同名称', key: 'contractName', width: '200px', placeholder: '请输入付款合同名称', align: 'center', input: 'input', defaultValue: "", required: true, },
            { label: '预计金额(元)', key: 'estimatedAmount', width: '150px', placeholder: '请输入预计金额', align: 'center', input: 'input', defaultValue: "", required: true, },
            { label: '是否付款', key: 'ifPay', width: '100px', placeholder: '', align: 'center', input: 'input', defaultValue: "", required: true, },
            { label: '预计日期', key: 'estimatedDate', width: '100px', placeholder: '请输入预计日期', align: 'center', input: 'date', defaultValue: "", required: true, },
            { label: '备注', key: 'note', width: '205px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        { key: 'paymentAmount', label: '本次付款金额(元)', span: 3, placeholder: '请输入本次付款金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '', amountCn: true, amountKeyName: 'paymentAmountCn' },
        { key: 'paymentAmountCn', label: '金额大写', span: 6, placeholder: '请输入金额大写', input: 'input', type: 'text', disabled: true, defaultValue: '' },

        { key: 'attachment', height: '450px', label: '附件', span: 6, placeholder: '请上传附件上传', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'notes', label: '备注', span: 6, placeholder: '请输入备注', input: 'textarea', type: 'textarea', disabled: true, defaultValue: '' },
      ],
      payContractForm: {
        supplierId: undefined,
        ownerId: undefined
      },
      rowData: {},
      cloneColumns: [],//复制一遍
      noDefaultValue: ['relatedItemsReceivePayment', 'supplierId', 'ownerId', 'makePaymentPlanList'],
      rules: {
        makePaymentName: [
          { required: true, message: '付款申请名称', trigger: 'blur' },
        ],
        supplierId: [

        ],
        // telecomOperatorSignComCode: [
        //   { required: true, message: '请选择运营商签约公司', trigger: 'blur' },
        // ],
        // telecomOperatorCode: [
        //   { required: true, message: '请选择运营商', trigger: 'change' },
        // ],
        makePaymentMethodType: [
          { required: true, message: '请选择付款方式', trigger: 'blur' }
        ],
        paymentTypeCode: [
          { required: true, message: '请选择付款类型', trigger: 'blur' },
        ],
        bankName: [
          { required: true, message: '请输入开户银行', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        ownerId: [

        ]
      },
      processList: [],
      processDescInfo: [],
      contractMakePaymentOption: [],
      supplierOption: [],
      ownerOption: [],
      contractReceivePaymentList: [],
      makePaymentPlanList: [],
      multipleSelection: []
    }
  },
  mounted() {
    this.dictOption('telecom_operator');
    this.dictOption('telecom_operator_sign_com');
    this.dictOption('payment_type');
    this.getOwnersList();
    this.getBasicSuppliersList();
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))
  },
  methods: {
    auditProcessStatus,
  // 判断付款计划是否已付款（1 / '1' / true 视为已付款，其余均为未付款）
  isPaid(val) {
    return val === 1 || val === '1' || val === true || val === 'true'
  },
  disabledSelect(row, index) {
    // 查看模式下全部禁用；其余模式下仅"未付款"的计划可勾选，"已付款"禁用
    if (this.status === 'view') return false
    return !this.isPaid(row.ifPay)
  },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let totalAmount = this.multipleSelection.reduce((sum, product) => sum + convertToNumberEnhanced(product.estimatedAmount), 0);
      this.$refs.descriptionsRef.detailsFormData['paymentAmount'] = totalAmount
      this.$refs.descriptionsRef.changeInputNumber(totalAmount, { amountCn: true, amountKeyName: 'paymentAmountCn' })
    },
    //组件change
    changeValue(v, item) {
      console.log(v, item)
      switch (item.key) {
        case 'supplierId':
          this.payContractForm.supplierId = v;
          this.getLedgerContractList()
          break;
        case 'ownerId':
          this.payContractForm.ownerId = v;
          this.getLedgerContractList()
          break;
        default:

          break;
      }
    },
    //核心方法 判断是否是新增 还是编辑
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值
            this.showDesc = true;
            if (this.columns[this.columns.length - 3].key == 'ifUploadInvoice') {
              this.columns.splice(this.columns.length - 3, 3);
            }
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            this.rowData = Object.assign({}, {});
            // this.reverseDisplayList({}, 'contractMakePaymentId')
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          case 'change':
            this.queryDetails({ id: row.id })
            break;
          case 'reAdd':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
      this.contractMakePaymentId = [];
      this.payContractForm.supplierId = undefined;
      this.payContractForm.ownerId = undefined;
      this.contractReceivePaymentList = [];
      this.makePaymentPlanList = [];
      this.multipleSelection = [];

    },
    //详情查询
    queryDetails(params) {
      this.loading = true;
      this.showDesc = true;
      queryFinMakePaymentDetailsApi(params).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          if (this.status !== 'add') {

            if (res.data.ifUploadInvoice == 1 && this.columns[this.columns.length - 3].key !== 'ifUploadInvoice') {
              this.columns.splice(this.columns.length, 0,
                {
                  key: 'ifUploadInvoice', label: '是否上传发票', span: 3, placeholder: '请选择是否上传发票', input: 'radio', type: '', disabled: true, defaultValue: '', option: [
                    { label: '是', value: 1 },
                    { label: '否', value: 0 },
                  ]
                },
                { key: 'uploadInvoiceTime', label: '上传发票时间', span: 3, placeholder: '请选择上传发票时间', input: 'date', type: '', disabled: true, defaultValue: '' },
                { key: 'uploadInvoiceUrl', height: '450px', label: '发票上传', span: 6, placeholder: '请上传发票', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
              )
            }
            this.contractMakePaymentId = res.data.contractMakePaymentIdList || [];
            this.payContractForm.supplierId = res.data.supplierId;
            this.payContractForm.ownerId = res.data.ownerId;
            this.getLedgerContractList()

            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              if (['ifUploadInvoice', 'uploadInvoiceTime', 'uploadInvoiceUrl'].includes(this.columns[i].key)) {
                this.columns[i].disabled = true;
              }
              if (!this.noDefaultValue.includes(this.columns[i].key)&&this.columns[i].key!=='paymentAmount'&&this.columns[i].key!=='paymentAmountCn') {
                this.columns[i].defaultValue = this.rowData[this.columns[i].key];
              }

            }
          }

        }
      }).catch(err => {
        this.loading = false;
      })
      this.queryProcessProject(params)
      this.qeuryAuditProcessDescription(params)
    },
    //提交
    submit(status = 1) {
      this.$refs.descriptionsRef.submit().then((formData = {}) => {
        console.log()
        // if ('relatedItemsReceivePayment' in formData) {
        //   delete formData.relatedItemsReceivePayment
        // }
        for (let key in formData) {
          if (this.noDefaultValue.includes(key)) {
            delete formData[key]
          }
        }
        let params = {
          makePaymentStatus: status,
          ...formData,
          contractMakePaymentIdList: this.contractMakePaymentId,
          supplierId: this.payContractForm.supplierId,
          ownerId: this.payContractForm.ownerId,
          makePaymentPlanIdList: [...this.multipleSelection.map(item => item.id)]
        }
        this.loading = true;
        if (this.status == 'add') {
          addFinMakePaymentApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else if (this.status == 'reAdd') {
          reAddFinMakePaymentApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else {
          editFinMakePaymentApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        }

      })
    },
    //暂存
    temporarilyStore() {
      this.submit(0);
    },
    //清空描述组件form
    clearForm() {
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'telecomOperatorCode' && type == 'telecom_operator') {
              item.option = res.data.rows || []
            } else if (item.key == 'telecomOperatorSignComCode' && type == 'telecom_operator_sign_com') {
              item.option = res.data.rows || []
            } else if (item.key == 'paymentTypeCode' && type == 'payment_type') {
              item.option = res.data.rows || []
            }
            return item
          })
        }
      })
    },
    //根据供应商和我方单位获取合同列表
    getLedgerContractList() {
      console.log('getLedgerContractList')
      let params = {
        supplierId: "",
        ownerId: "",
        ...this.payContractForm
      }
      if (!params.supplierId || !params.ownerId) {
        return false
      }
      getListYtgBySupAndOwnApi(params).then(res => {
        if (res.code == 200) {
          this.contractMakePaymentOption = res.data;
        }
      })
    },
    //供应商下拉
    getBasicSuppliersList() {
      let params = {
        supplierName: ''
      }
      queryBasicSuppliersListApi(params).then(res => {
        if (res.code == 200) {
          this.supplierOption = res.data;
        }
      })
    },
    //我方负责单位下拉
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.ownerOption = res.data;
        }
      })
    },
    // 通过合同-获取付款申请和付款数据
    getInvoiceAndReceivedDataContract(id) {
      let params = {
        id,
      }
      getInvoiceAndReceivedDataApi(params).then(res => {
        if (res.code == 200) {
          this.contractReceivePaymentList.push(res.data);
          const uniqueArr = this.contractReceivePaymentList.filter((item, index, self) => index === self.findIndex(t => t.contractMakePaymentId === item.contractMakePaymentId));
          this.contractReceivePaymentList = uniqueArr;
        }
      })
    },
    // 通过付款合同-获取已付款和未付款
    getMakePaymentData(id) {
      let params = {
        id,
      }
      getMakePaymentDataApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'makePaymentAmount') {
              item.defaultValue = res.data.makePaymentAmount;
            }
            if (item.key == 'noMakePaymentAmount') {
              item.defaultValue = res.data.noMakePaymentAmount;
            }
            return item
          })
        }
      })
    },
    // 获取付款合同的付款计划
    getContractMakePaymentPlan(id) {
      let params = {
        id,
      }
      getContractMakePaymentPlanApi(params).then(res => {
        if (res.code == 200) {
          if (Array.isArray(res.data)) {
            for (let i = 0; i < res.data.length; i++) {
              this.makePaymentPlanList.push(res.data[i]);
            }
            const uniqueArr = this.makePaymentPlanList.filter((item, index, self) => index === self.findIndex(t => t.id === item.id));
            uniqueArr.sort((itemS, itemE) => itemS.id - itemE.id)
            this.makePaymentPlanList = uniqueArr;
            this.$nextTick(() => {
              if (!this.rowData.hasOwnProperty('id')) return false;
              const table = this.$refs.makePaymentPlanIdRef;
              this.makePaymentPlanList.forEach(row => {
                const inApp = this.rowData.makePaymentPlanIdList && this.rowData.makePaymentPlanIdList.includes(row.id)
                // 回显：该付款申请已包含、且为"未付款"（可勾选）的计划，在查看/编辑模式下默认勾选
                if (inApp && !this.isPaid(row.ifPay) && (this.status === 'view' || this.status === 'edit')) {
                  table.toggleRowSelection(row, true);
                }
              });
            });
          }
        }
      })
    },
    remoteMethod(query, current = '') {
      if (query !== '') {
        switch (current) {
          case 'contractMakePaymentId':
            this.getLedgerContractList(query)
            break;
          default:
            break;
        }
      } else {
        this.projectOptions = [];
        this.contractMakePaymentOption = [];
      }
    },
    //审批进度
    queryProcessProject(params) {
      processFinMakePaymentApi(params).then(res => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      })
    },
    qeuryAuditProcessDescription(params) {
      queryAuditProcessDescriptionApi(params).then(res => {
        if (res.code == 200) {
          this.processDescInfo = res.data.avatars;
        }
      })
    },
    //关联付款情况反显
    reverseDisplayList(id, current, itemKey) {
      //['relatedItemsReceivePayment','makePaymentAmount','noMakePaymentAmount','makePaymentPlanList']
      if (current) {
        if (current == 'contractMakePaymentId' && id) {
          switch (itemKey) {
            case 'relatedItemsReceivePayment':
              this.getInvoiceAndReceivedDataContract(id)
              break;
            case 'makePaymentPlanList':
              this.getContractMakePaymentPlan(id)
              break;
            case 'all':
              this.getInvoiceAndReceivedDataContract(id)
              this.getContractMakePaymentPlan(id)
              break;
            default:
              break;
          }

        } else {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = [
                {
                  totalAmount: '--',
                  noInvoicedAmount: '--',
                  noReceivedAmount: '--',
                  receivedAmount: '--',
                  invoicedAmount: '--'
                }
              ]
            }
            return item
          })
        }
      }
    },
    //关闭详情 刷新页面
    childReviewer(row) {
      this.closeDrawer()
      this.$emit('parReviewer')
    },
  }
}
</script>

<style scoped lang="scss">
.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}
.progress-box{
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  margin-bottom: 5px;
  background: #285af1;
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
    color: #fff;
  }
  .progress-desc-info {
    padding: 10px 0px 10px 0px;

    .items {
      font-size: 15px;
      display: inline-block;
      vertical-align: middle; 
    }
  }
}
.approval-progress {
  padding: 5px;
  box-sizing: border-box;
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
  }

  .progress-con {
    .progress-desc {
      line-height: 20px;
      color: #303133;

      .progress-time {
        margin-left: 10px;
        color: #909399;
      }

      .notes-text {
        display: -webkit-box;
        /* 设置为弹性盒子模型 */
        -webkit-box-orient: vertical;
        /* 垂直排列 */
        -webkit-line-clamp: 2;
        /* 显示最多 3 行 */
        overflow: hidden;
        /* 隐藏超出的部分 */
        text-overflow: ellipsis;
        /* 使用省略号 */
      }

      .signature-box {
        width: 180px;
        height: 50px;
        overflow: hidden;

        .signature-title {
          display: block;
          width: 40px;
        }

        .signature-img {
          margin-left: 10px;
          width: 180px;
        }
      }
    }

    .makeACopyFor-desc {
      line-height: 20px;
      color: #303133;

      .makeACopyFor-title {}

      .makeACopyFor-num {
        color: #909399;
      }

      .makeACopyFor-box {
        .child-items {
          padding-right: 5px;
          box-sizing: border-box;

          .child-text {
            text-align: center;
          }
        }
      }
    }
  }
}

::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}

::v-deep .el-breadcrumb__separator {
  color: #fff;
}

::v-deep .des-label {
  font-weight: bold;
}

:v-deep .el-input__inner {
  border: 1px solid #989a9c !important;
}

::v-deep .el-table thead {
  color: #0094da;
  font-weight: 500;
}
</style>
